/* eslint-disable no-alert */
import { getSocialLoginUrl } from '../../../../../../../api/cognito/getSocialLoginUrl';
import { ErrorCause } from '../../../../../types/errors/ErrorCause';
import { Context } from '../../types';

interface OAuthArgs {
  helpers: Pick<Context['helpers'], 'checkForTokens' | 'setSignupMethod'>;
  OAuth: Pick<Context['OAuth'], 'method' | 'platform' | 'windowWidth'>;
}

export const handleOAuth = async ({ helpers, OAuth }: OAuthArgs): Promise<boolean> => {
  const { checkForTokens, setSignupMethod } = helpers;
  const { method, platform, windowWidth } = OAuth;
  const { CognitoError, RegistrationError, TokenError, WindowError } = ErrorCause;
  const registrationErrorMessage = 'An error occurred while signing up. Please try again.';
  const windowErrorMessage = 'User attempted to sign up but popup window failed to open.';
  setSignupMethod(method);
  const url = getSocialLoginUrl(platform);
  const authWindow = window.open(url, '_blank', `height=570,width=${windowWidth},scrollbars=no`);

  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      if (!authWindow) {
        clearInterval(interval);

        alert('Could not open a popup to sign up. Do you have a popup blocker enabled?');

        reject(new Error(windowErrorMessage, { cause: WindowError }));
        return;
      }

      if (authWindow.closed) {
        clearInterval(interval);

        const cognitoError = localStorage.getItem('COGNITO_ERROR');
        if (cognitoError) {
          localStorage.removeItem('COGNITO_ERROR');

          reject(new Error(cognitoError, { cause: CognitoError }));
          return;
        }

        try {
          const isAuthenticated = await checkForTokens();

          if (isAuthenticated) {
            resolve(isAuthenticated);
            return;
          }

          reject(new Error(registrationErrorMessage, { cause: RegistrationError }));
          return;
        } catch (error) {
          reject(new Error(error.message, { cause: TokenError }));
          return;
        }
      }
    }, 100);
  });
};
